import React from 'react';
import ReactDOM from 'react-dom/client';
import { AppProvider } from '@shopify/polaris';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import translations from '@shopify/polaris/locales/fr.json';
import '@shopify/polaris/build/esm/styles.css';

import App from './App';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60,
      retry: 1,
    },
  },
});

// Get params from URL
const params = new URLSearchParams(window.location.search);
const host = params.get('host');
const shop = params.get('shop');
const idToken = params.get('id_token');

// Store in sessionStorage
if (host) sessionStorage.setItem('shopify-host', host);
if (shop) sessionStorage.setItem('shopify-shop', shop);
if (idToken) sessionStorage.setItem('shopify-id-token', idToken);

// Initialize Shopify App Bridge if available
declare global {
  interface Window {
    shopify?: any;
  }
}

if (window.shopify && host) {
  // App Bridge is loaded via CDN
  console.log('Shopify App Bridge initialized');
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AppProvider i18n={translations}>
        <App />
      </AppProvider>
    </QueryClientProvider>
  </React.StrictMode>
);
